import { FC } from "react";
import { Collapse } from "antd";
import cn from "classnames";
import { MdKeyboardArrowDown } from "react-icons/md";
import { SegmentType } from "src/Modules/Flights/constants";
import { SegmentBody, SegmentHeader } from "./components";

const SegmentCard: FC<{ segment: SegmentType; segmentNumber: number }> = ({ segment, segmentNumber }) => {
  return (
    <Collapse
      ghost
      expandIconPlacement="end"
      defaultActiveKey={"collapse-1"}
      expandIcon={({ isActive }) => (
        <span className="border-border-default text-icon-default flex size-8 items-center justify-center rounded-md!">
          <MdKeyboardArrowDown className={cn("size-5 transition-transform", isActive && "rotate-180")} />
        </span>
      )}
      classNames={{
        header: "items-center! p-0!",
        body: "p-0! py-5!",
      }}
      items={[
        {
          label: <SegmentHeader segment={segment} segmentNumber={segmentNumber} />,
          key: "collapse-1",
          children: <SegmentBody segment={segment} />,
        },
      ]}
    />
  );
};

export default SegmentCard;;
